import RouterSection from '@/Layout/components/RouterSection'

export default {
  path: '/company',
  name: 'company',
  component: RouterSection,
  mode: 'history',
  children: [
    // 개인정보 & 약관
    {
      path: 'terms',
      name: 'terms',
      component: () => import('@/views/company/Terms.vue')
    }
  ]
}
